import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.URL + 'locations',
  GROUPS_URL: API.GRAPHQL_URL + 'groups',
  GRAPHQL_URL: `${API.GRAPHQL_URL}locations`,
  import (file) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/import`, file)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  create (location) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}`, location)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  update (id, location) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/${id}`, location)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  fetch (location_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${location_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  relatedSummary (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${id}/related-summary`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchAll (page = 1) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}?limit=30&page=${page}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchPaginated (options = {}) {
    const { page, search, franchiseId, limit } = {
      ...{
        page: 1,
        search: null,
        franchiseId: null,
        limit: 30
      },
      ...options
    }
    const isOnAdmin = options.isOnAdmin ? options.isOnAdmin : false
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}?limit=${limit}&page=${page}` + (search ? `&search=${search}` : '')
        + (franchiseId ? `&franchiseId=${franchiseId}` : ''),
        { params: { isOnAdmin } }
      )
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  // La exportacion se genera en el backend (cola exports-heavy) y llega por
  // correo con un link a S3: el navegador ya no arma el Excel ni pide las
  // ubicaciones con limit=10000.
  exportToEmail (emailList = []) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/export`, { emailList }, { params: { isOnAdmin: true } })
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchFiltered (search) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}?limit=30&page=1&search=${search}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  hasUniqueFolio (locationId, folio) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${locationId || 0}/available_folio/${encodeURIComponent(folio)}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchGroups () {
    return new Promise((resolve, reject) => {
      http.get(this.GROUPS_URL)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },
  saveGroup (payload) {
    return new Promise((resolve, reject) => {
      http.post(this.GROUPS_URL, payload)
        .then(() => {
          http.get(this.GROUPS_URL)
            .then(response => resolve(response.data.data))
        })
        .catch(error => reject(error))
    })
  },
  updateGroup (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GROUPS_URL}/${payload.id}`, payload)
        .then(group => resolve(group))
        .catch(err => reject(err))
    })
  },
  deleteGroup (groupId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GROUPS_URL}/${groupId}`)
        .then(() => {
          http.get(this.GROUPS_URL)
            .then(response => resolve(response.data.data))
        })
        .catch(error => reject(error))
    })
  },
  reorderGroups (ids) {
    return http.put(`${this.GROUPS_URL}/reorder`, { ids })
  },
  fetchLevelSortTypes () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GROUPS_URL}/level-sort-types`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  updateGroupLevelSortType (level, sortType) {
    return http.put(`${this.GROUPS_URL}/level-sort-type`, { level, sort_type: sortType })
  },
  deleteLogo (id) {
    return new Promise((resolve, reject) => {
      http.put(`${API.GRAPHQL_URL}location/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchByValue (payload) {
    const params = { search: payload.search }
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}locations/getByValue`, { params })
        .then(response => { resolve(response.data.data) })
        .catch(error => { reject(error) })
    })
  }
}
